import $ from "jquery";
const Site = {
  SiteName: "https://www.vagaro.com/",
  MySiteName: "mysite.vagaro.com",
  VagaroCoreApiUrl: "https://mysiteapi.vagaro.com"
}

const utils = {
  Validate: (value) => {
    if (typeof value != undefined && value != null && value != "" && value != 'undefined') {
      return true;
    }
    else {
      return false;
    }
  },
  MultiLocationData: function (data, businessid) {
    var MultiLocationGroup = $.grep(data.MultilocationData, function (LocationType) {
      return (LocationType.encBIDHash == businessid);
    });
    if (MultiLocationGroup.length > 0) {
      return MultiLocationGroup[0];
    }
    else {
      return [];
    }
  },
  FlagshipBusinessData: function (data,SnyBusinessID) {
    var MultiLocationGroup = $.grep(data.MultilocationData, function (LocationType) {
      return LocationType.staticEncBID === SnyBusinessID
    });

    if (MultiLocationGroup.length > 0) {
      return MultiLocationGroup[0];
    } else {
      return {};
    }
  }
}

export { utils, Site }

